import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("simpa_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const BIODATA_STORAGE = "simpa_biodata";

export const loadBiodata = () => {
  try {
    return JSON.parse(localStorage.getItem(BIODATA_STORAGE) || "{}");
  } catch { return {}; }
};

export const saveBiodata = (data) => {
  localStorage.setItem(BIODATA_STORAGE, JSON.stringify(data));
};

const HISTORY_KEY = "simpa_history";

export const loadHistory = () => {
  try {
    return JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]");
  } catch { return []; }
};

export const addHistory = (entry) => {
  const list = loadHistory().filter((h) => h.id !== entry.id);
  list.unshift(entry);
  localStorage.setItem(HISTORY_KEY, JSON.stringify(list.slice(0, 50)));
};

export const removeHistory = (id) => {
  localStorage.setItem(HISTORY_KEY, JSON.stringify(loadHistory().filter((h) => h.id !== id)));
};
